import React, { useState } from "react";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { SUBSTACK_URL } from "../../mock/mock";

const SPLIT_IMG =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_mindful-owner/artifacts/2fp0e7th_bd5aab6498ae3d7e4286225ff260f281.jpg";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SplitCTA = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      await axios.post(`${API}/subscribe`, { email, source: "waitlist" });
      setStatus("ok");
    } catch (err) {
      setStatus("err");
    }
    setEmail("");
    setTimeout(() => setStatus("idle"), 5000);
  };

  return (
    <section className="grid md:grid-cols-2 min-h-[560px] md:min-h-[640px]">
      <div className="relative min-h-[320px] md:min-h-full">
        <img
          src={SPLIT_IMG}
          alt="Quiet light"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      <div className="bg-[#B995EE] flex items-center justify-center px-6 md:px-14 py-20 md:py-24">
        <div className="max-w-lg om-fade-up">
          <div className="uppercase tracking-[0.28em] text-[0.72rem] text-[#41232E]/70 mb-6">
            Who this is for
          </div>

          <h2 className="font-serif-display text-[#41232E] text-3xl md:text-4xl lg:text-[2.75rem] leading-[1.08] tracking-[-0.015em]">
            The Owner&rsquo;s Mind is for people{" "}
            <em className="italic">actively building</em> something in their lives.
          </h2>

          <p className="mt-6 text-[#41232E]/85 text-base md:text-[1.05rem] leading-relaxed">
            A career. A business. A brand. Better health. Financial security. A new chapter. Or
            simply more of the life they want.
          </p>

          <p className="mt-4 text-[#41232E]/85 text-base md:text-[1.05rem] leading-relaxed">
            Get practical ideas, frameworks and lessons from what I&rsquo;ve learned over 20+ years
            &mdash; and connect with other Owners who are setting goals, taking action and building
            alongside you.
          </p>

          <div className="mt-8">
            <div className="uppercase tracking-[0.22em] text-[0.7rem] text-[#41232E]/70 mb-3">
              Join the waiting list
            </div>
            <form onSubmit={onSubmit}>
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  className="flex-1 bg-[#FFFDF6] rounded-full px-6 py-3.5 border border-[#41232E]/15 focus:border-[#41232E] outline-none text-[#41232E] placeholder:text-[#41232E]/45 transition-colors"
                />
                <button
                  type="submit"
                  disabled={status === "loading" || status === "ok"}
                  className="shrink-0 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 bg-[#41232E] text-[#FFFDF6] font-medium hover:bg-[#2c161e] transition-colors disabled:opacity-70"
                >
                  {status === "loading" ? "Adding you\u2026" : status === "ok" ? "You're on the list" : "Join the waiting list"}
                  {status !== "ok" && <ArrowRight size={16} />}
                </button>
              </div>
              {status === "ok" && (
                <div className="mt-3 text-sm text-[#41232E]/85">
                  Nice &mdash; you&rsquo;ll be the first to know when new work drops.
                </div>
              )}
              {status === "err" && (
                <div className="mt-3 text-sm text-[#41232E]/85">
                  Couldn&rsquo;t save right now &mdash; please try again in a moment.
                </div>
              )}
              {status === "idle" && (
                <div className="mt-3 text-xs text-[#41232E]/70">
                  Early access to new essays, frameworks, and community drops.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
      </section>
  );
};

export default SplitCTA;
